<template>
    <v-card flat class="ma-0 pa-0">
        <v-card-text class="pa-4 pl-4">
            <slot></slot>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "CardedDisplay"
}
</script>